import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DonationTabs from './DonationTabs';
import FundOptions from './FundOptions';
import DonationAmounts from './DonationAmounts';
import Zakat from '../Zakat';
import TipCard from '../TipCard';
import DonationSummary from './DonationSummary';
import PaymentMethodSelector from './PaymentMethodSelector';

const DonationForm = ({
  activeTab,
  setActiveTab,
  funds,
  selectedFund,
  setSelectedFund,
  donationOptions,
  selectedAmount,
  setSelectedAmount,
  customAmount,
  setCustomAmount,
  getCurrentAmount,
  getAutoAjrAmount,
  getTotalAmount,
  paymentMethod,
  setPaymentMethod,
  paymentError,
  formErrors,
  handleDonationSubmit,
  onTipSubmit,
  isZakat,
  onZakatChange
}) => {
  const { t } = useTranslation();
  const [isFormValid, setIsFormValid] = useState(false);

  return (
    <form onSubmit={handleDonationSubmit} className="p-4">
      <DonationTabs activeTab={activeTab} setActiveTab={setActiveTab} />
      
      <FundOptions 
        funds={funds} 
        selectedFund={selectedFund} 
        setSelectedFund={setSelectedFund} 
      />
      
      <DonationAmounts 
        activeTab={activeTab}
        donationOptions={donationOptions}
        selectedAmount={selectedAmount}
        setSelectedAmount={setSelectedAmount}
        customAmount={customAmount}
        setCustomAmount={setCustomAmount}
      />
      
      {/* <Zakat 
        isZakat={isZakat}
        onZakatChange={onZakatChange}
      /> */}
      
      <TipCard 
        donationType={activeTab}
        donationAmount={getCurrentAmount()} 
        onTipSubmit={onTipSubmit} 
      />
      
      <DonationSummary 
        activeTab={activeTab}
        currentAmount={getCurrentAmount()}
        autoAjrAmount={getAutoAjrAmount()}
        totalAmount={getTotalAmount()}
      />
      
      <PaymentMethodSelector 
        paymentMethod={paymentMethod}
        setPaymentMethod={setPaymentMethod}
        formErrors={formErrors}
        onValidationChange={setIsFormValid}
      />
      
      {paymentError && (
        <div style={{
          backgroundColor: '#fee2e2',
          border: '1px solid #f87171',
          color: '#b91c1c',
          paddingLeft: '1rem',
          paddingRight: '1rem',
          paddingTop: '0.75rem',
          paddingBottom: '0.75rem',
          borderRadius: '0.25rem',
          marginBottom: '1rem'
        }}>
          {paymentError}
        </div>
      )}
      
      <button
        type="submit"
        disabled={!isFormValid}
        style={{
          width: '100%',
          paddingTop: '1rem',
          paddingBottom: '1rem',
          backgroundColor: isFormValid ? 'var(--primary-color)' : '#9ca3af',
          color: 'white',
          fontWeight: '700',
          borderRadius: '0.5rem',
          border: 'none',
          cursor: isFormValid ? 'pointer' : 'not-allowed',
          transition: 'all 0.2s ease-in-out',
          transform: 'scale(1)',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          marginBottom: '2rem',
          opacity: isFormValid ? 1 : 0.6
        }}
        onMouseEnter={(e) => {
          if (isFormValid) {
            e.currentTarget.style.backgroundColor = 'var(--eigth-color)';
            e.currentTarget.style.transform = 'scale(1.02)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
          }
        }}
        onMouseLeave={(e) => {
          if (isFormValid) {
            e.currentTarget.style.backgroundColor = 'var(--primary-color)';
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
          }
        }}
      >
        {t('autoAjr.checkout')}
      </button>
    </form>
  );
};

export default DonationForm;